export const getUrl = (path: string) => {
  return `https://admin.www.w.se/${path}`
}